import Popup from "./Popup.vue"

export default Popup